import React, { useState, useEffect } from "react";
import './App.css';

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Main from "./Main";
import { Katharsis } from "./song links/Katharsis";
import { ARE } from "./song links/ARE";
import { Fuehler } from "./song links/Fuehler";
import { Endlosschleifen } from "./song links/Endlosschleifen";
import { Paradies } from "./song links/Paradies";
import { Maschinen } from "./song links/Maschinen";
import { Vergissmeinnicht } from "./song links/Vergissmeinnicht";
import { AZU } from "./song links/AZU";
import { BKA } from "./song links/BKA";
import { Transformation } from "./song links/Transformation";
import { Tiefseetauchen } from "./song links/Tiefseetauchen";


function App() {
  // State for width (typed as number)
  const [width, setWidth] = useState<number>(window.innerWidth);

  // Update width on resize
  useEffect(() => {
    const updateWidth = () => setWidth(window.innerWidth);

    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const isMobile = width < 800;

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Main width={width} isMobile={isMobile} />} />
          <Route path="/katharsis" element={<Katharsis />} />
          <Route path="/abwaertsradeleuphorie" element={<ARE />} />
          <Route path="/fuehler" element={<Fuehler />} />
          <Route path="/endlosschleifen" element={<Endlosschleifen />} />
          <Route path="/paradies" element={<Paradies />} />
          <Route path="/maschinen" element={<Maschinen />} />
          <Route path="/vergissmeinnicht" element={<Vergissmeinnicht />} />
          <Route path="/azu" element={<AZU />} />
          <Route path="/bka" element={<BKA />} />
          <Route path="/transformation" element={<Transformation />} />
          <Route path="/tiefseetauchen" element={<Tiefseetauchen />} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
